import React, { useEffect, useState } from 'react';
import { icons } from './ui/Icons';
import { calculateAverageRating } from '../services/reviewService';

/**
 * Componente: BarbershopCard (/components/BarbershopCard.jsx)
 * Card para exibir uma barbearia na lista
 */
const BarbershopCard = ({ shop, onNavigate }) => {
  const [reviewStats, setReviewStats] = useState({ average: shop.rating || 0, total: 0 });

  useEffect(() => {
    const loadReviewStats = async () => {
      const result = await calculateAverageRating(shop.id);
      if (result.success && result.data.total > 0) {
        setReviewStats(result.data);
      }
    };

    loadReviewStats();
  }, [shop.id]);

  return (
    <div
      className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl cursor-pointer"
      onClick={() => onNavigate('barbershop', { id: shop.id })}
    >
      <div className="relative">
        <img
          className="h-48 w-full object-cover"
          src={shop.bannerUrl.replace('1200x400', '600x300')} // Imagem menor
          alt={shop.name}
        />
        {shop.isSponsored && (
          <div className="absolute top-3 right-3 bg-yellow-400 text-yellow-900 px-2 py-0.5 rounded-full text-xs font-bold flex items-center">
            {icons.star({ className: 'h-3 w-3 fill-current mr-1' })}
            PATROCINADO
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-900 mb-1 truncate" title={shop.name}>{shop.name}</h3>
        <div className="flex items-center mb-3">
          {icons.star({ className: 'h-5 w-5 text-yellow-500 fill-current' })}
          <span className="ml-1 text-gray-700 font-semibold">{reviewStats.average}</span>
          <span className="text-gray-500 ml-2">
            ({reviewStats.total} {reviewStats.total === 1 ? 'avaliação' : 'avaliações'})
          </span>
        </div>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">{shop.description}</p>
        <div className="flex items-center text-sm text-gray-500">
          {icons.mapPin({ className: 'h-4 w-4 mr-1.5' })}
          {shop.city}
        </div>
      </div>
    </div>
  );
};

export default BarbershopCard;
